import React, { useState } from "react";
import {FaMinus, FaPlus, FaFileMedical, FaShieldAlt, FaLock, FaKey, FaCloud, FaUserShield, FaDatabase, FaServer,FaUserCheck,FaCloudUploadAlt, FaCloudDownloadAlt, FaSync } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcareDataSecurity/SecureCloud.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        title: "HIPAA-Compliant Cloud Storage",
        description:
          "Ensures the secure storage of electronic health records (EHRs) by adhering to HIPAA regulations. This includes encryption, access controls, and audit logs to prevent unauthorized access. Cloud providers offering HIPAA compliance must implement safeguards such as Business Associate Agreements (BAA), encrypted data transmission, and regular security audits."
      },
      {
        title: "End-to-End Data Encryption",
        description:
          "Encrypts patient data both in transit (during transmission between devices) and at rest (while stored in the cloud). This prevents unauthorized access, even if a breach occurs. Advanced encryption protocols like AES-256 and TLS ensure that sensitive medical information remains confidential and secure against cyber threats."
      },
      {
        title: "Automated Backup & Disaster Recovery",
        description:
          "Provides regular data backups and a robust disaster recovery plan to ensure medical records remain accessible in case of system failures, ransomware attacks, or natural disasters. Cloud-based redundancy ensures minimal downtime and quick restoration of lost data, reducing operational disruptions in healthcare facilities."
      },
      {
        title: "Role-Based Access Control (RBAC)",
        description:
          "Restricts access to medical data based on user roles, ensuring that only authorized personnel (e.g., doctors, nurses, administrators) can view, modify, or share patient records. RBAC helps enforce the principle of least privilege (PoLP), minimizing the risk of data breaches and internal threats."
      },
      {
        title: "Multi-Factor Authentication (MFA)",
        description:
          "Adds an extra layer of security by requiring multiple authentication steps before accessing cloud-stored data. This typically involves a combination of passwords, one-time passcodes (OTP), and biometric verification, preventing unauthorized access even if login credentials are compromised."
      },
      {
        title: "Secure File Sharing & Collaboration",
        description:
          "Enables healthcare professionals to securely share patient records with colleagues while maintaining compliance with HIPAA and other regulations. Features such as end-to-end encrypted sharing, access expiration controls, and activity logs ensure that shared files remain protected from unauthorized access or misuse."
      }
    ];
const features = [
    { icon: <FaCloud className="text-[#2a627a] text-lg" />, text: "Scalable cloud storage for large medical datasets and EHRs." },
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "AES-256 encryption ensures maximum data security." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "HIPAA and GDPR compliance for secure patient data storage." },
    { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Dedicated cloud servers for fast and secure healthcare access." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Secure storage for medical images, lab reports, and prescriptions." },
    { icon: <FaSync className="text-[#2a627a] text-lg" />, text: "Real-time synchronization for immediate data access across devices." }
];

const benefits = [
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Reduces on-premise data storage costs with cloud solutions." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Prevents unauthorized data access through strict security protocols." },
    { icon: <FaCloudUploadAlt className="text-[#2a627a] text-lg" />, text: "Facilitates easy and secure data uploads from multiple sources." },
    { icon: <FaCloudDownloadAlt className="text-[#2a627a] text-lg" />, text: "Allows quick and seamless retrieval of patient records." },
    { icon: <FaKey className="text-[#2a627a] text-lg" />, text: "Secure key management for controlled access to stored healthcare data." },
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Enhances patient data accessibility for authorized healthcare providers." }
];
const cmsFeatures = [
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Cloud Security Administrator – Manages cloud storage security and compliance." },
    { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Healthcare IT Specialist – Oversees cloud infrastructure and performance." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "EHR Data Manager – Ensures medical records are securely stored and accessed." },
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "Compliance Officer – Maintains adherence to HIPAA, GDPR, and other regulations." },
    { icon: <FaKey className="text-[#2a627a] text-lg" />, text: "Cloud Access Manager – Manages identity and access control policies." },
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Data Backup Specialist – Handles cloud backup strategies and disaster recovery." }
];

const Securecloudstorage = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Secure cloud storage - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Secure Cloud Storage ensures encrypted data protection, access control, compliance, and reliable backups for safe healthcare data management."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Secure Cloud Storage?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Secure cloud storage is a protected, scalable, and encrypted digital space where healthcare organizations can store, manage, and share sensitive medical data. It ensures that electronic health records (EHRs), medical images, telehealth consultations, and research data are accessible only to authorized users while being guarded against cyber threats and data breaches.

At HIKEHEALTH GS, we offer HIPAA-compliant, AI-powered secure cloud solutions designed to protect patient data, improve interoperability, and enhance healthcare efficiency.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Secure Cloud Storage
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Securecloudstorage;
